export interface VersionHistory {
    version: string;
    date: string;
    changes: string[];
}

export const APP_VERSION = '1.10';
export const COMMIT_HASH = 'ef6ff8c';

export const VERSION_HISTORY: VersionHistory[] = [
    {
        version: '1.10',
        date: '2026-01-04',
        changes: [
            'Feature : Identifiants de chantier "Humains" (CH-YYMM-XXXX) avec génération séquentielle',
            'Feature : Refonte critique du système Backup/Restore (Inclusion Véhicules + Sécurité)',
            'UX : Nouvelle palette de statuts haute visibilité (Planifié = Orange, En Cours = Bleu)',
            'Fix : Persistance des modifications depuis le Drag & Drop et la Modale Planning',
            'Fix : Correction des contrastes en Mode Clair sur l\'ensemble des pages Admin'
        ]
    },
    {
        version: '1.09',
        date: '2026-01-03',
        changes: [
            'Fix : Résolution critique erreur "split undefined" sur le planning (Info-bulles)',
            'Fix : Sécurisation de l\'export CSV des chantiers (Compatibilité Date)',
            'Infra : Optimisation de la stabilité WebSocket (CORS x-socket-id)',
            'Infra : Amélioration de la robustesse du typage sur les status de planning'
        ]
    },
    {
        version: '1.08',
        date: '2026-01-03',
        changes: [
            'Fix : Résolution des synchronisations temps réel (Backlog & Drag-and-Drop)',
            'Fix : Correction erreur 403 (Token Migration) sur les routes protégées',
            'Backlog : Rafraîchissement automatique multi-clients',
            'Planning : Chargement optimisé des assignations techniciens'
        ]
    },
    {
        version: '1.07',
        date: '2025-12-28',
        changes: [
            'UX : Unification de la pop-in de création d\'intervention (Même design pour Planning & Backlog)',
            'UX : Nouveau système de notifications Toast "Neo-Glass" pour un feedback utilisateur premium',
            'Mobile : Agenda revisité avec Timeline, statuts visuels et Actions Rapides (Start/Finish/Call/Maps)',
            'Planner : Création intelligente (Assignation directe ou ajout au Backlog selon sélection)',
            'Admin : Gestion dynamique des thèmes (Suppression et Définition du thème par défaut)',
            'Dashboard : Statistiques opérationnelles en temps réel (Dispo techniciens / Outillage)'
        ]
    },
    {
        version: '1.06',
        date: '2025-12-28',
        changes: [
            'Sécurité : Renforcement critique du Backend (JWT Secret, Validation Zod)',
            'Sécurité : Système de logs complet (IP réelle, User Agent)',
            'Admin : Nouveau Dashboard "Logs de Sécurité" (Monitoring, Stats, Filtres)',
            'Admin : Export CSV des tentatives de connexion et conformité RGPD (Rétention 90j)',
            'Infra : Support amélioré des Proxies (Cloudflare/Vercel) pour la détection IP',
            'Infra : Gestion robuste des clés VAPID (Notifications Push optionnelles)'
        ]
    },
    {
        version: '1.05',
        date: '2025-12-28',
        changes: [
            'Refonte complète de l\'UX mobile pour les techniciens',
            'Ajout du footer global sur toutes les pages (Branding ma-dsi.info)',
            'Mise à jour optimiste des statuts (Démarrer/Terminer) - Réactivité instantanée',
            'Confirmation de clôture d\'intervention + Retour auto au planning',
            'Amélioration visuelle du planning : couleurs de statut distinctes (Bleu/Orange/Vert)',
            'Normalisation des badges de statut sur mobile (Support in-progress/in_progress)',
            'Ajout du bouton Rafraîchir sur l\'interface mobile',
            'Amélioration de l\'espacement et lisibilité de la grille Planning'
        ]
    },
    {
        version: '1.04',
        date: '2025-12-28',
        changes: [
            'Mise à jour majeure du système de Sauvegarde & Restauration',
            'Passage à une génération de sauvegarde 100% locale (JSON Client-Side)',
            'Inclusion complète de la Flotte de Véhicules dans les sauvegardes',
            'Suppression des dépendances serveur pour la création de backups (Plus rapide et fiable)'
        ]
    },
    {
        version: '1.03',
        date: '2025-12-28',
        changes: [
            'Refonte visuelle complète de la page Gestion de Flotte (Style Outillage)',
            'Ajout des indicateurs KPI et Filtres unifiés sur le parc véhicules',
            'Harmonisation des en-têtes de page avec icônes représentatives',
            'Finalisation de la cohérence visuelle Planning / Flotte / Outillage / Admin'
        ]
    },
    {
        version: '1.02',
        date: '2025-12-25',
        changes: [
            'Ajout du thème Minimalist (Slate / High-End)',
            'Correction du chevauchement dans le planning (Colonnes "Sticky" opaques)',
            'Suppression du bouton de thème dans le Header (Centralisation dans les Paramètres)',
            'Ajustement des Z-Index pour un défilement fluide du planning'
        ]
    },
    {
        version: '1.01',
        date: '2025-12-25',
        changes: [
            'Initialisation du suivi de version',
            'Ajout du thème Hybride (Next-Gen)',
            'Ajout du thème Sharp (Flat)',
            'Correction des contrastes blanc sur blanc dans le Header',
            'Passage des polices en Monospace pour le thème Sharp'
        ]
    }
];
